import { Alert } from "antd";

type ErrorContainerProps = {
  title: string;
};

export const ErrorContainer = ({ title }: ErrorContainerProps) => {
  return <Alert type="error" message={title} showIcon className="mb-10" />;
};
